import isInBetween from '../isInBetween';

/**
 * Enum to represent different parts of the day
 */
export var PartOfTheDay = /*#__PURE__*/function (PartOfTheDay) {
  PartOfTheDay["EARLY_MORNING"] = "early_morning";
  PartOfTheDay["MORNING"] = "morning";
  PartOfTheDay["AFTERNOON"] = "afternoon";
  PartOfTheDay["EVENING"] = "evening";
  PartOfTheDay["LATE_NIGHT"] = "late_night";
  return PartOfTheDay;
}({});

/**
 * Util function to get part of the day based on local time
 * @returns  part of the day i.e. early morning, morning,
 * afternoon, evening, late-night etc
 * Used on course page, sample design specs:
 * https://www.figma.com/file/iI9YeDZgcJEB7flqaiX08R/Course-Dash-H2-Milestone-1-2022?node-id=1747%3A200790
 */
var getPartOfTheDay = function getPartOfTheDay() {
  var currentHour = new Date().getHours();
  if (isInBetween({
    lower: 4,
    upper: 7,
    toBeCompared: currentHour,
    isLowerBoundInclusive: true
  })) {
    return PartOfTheDay.EARLY_MORNING;
  }
  if (isInBetween({
    lower: 7,
    upper: 12,
    toBeCompared: currentHour,
    isLowerBoundInclusive: true
  })) {
    return PartOfTheDay.MORNING;
  }
  if (isInBetween({
    lower: 12,
    upper: 17,
    toBeCompared: currentHour,
    isLowerBoundInclusive: true
  })) {
    return PartOfTheDay.AFTERNOON;
  }
  if (isInBetween({
    lower: 17,
    upper: 23,
    toBeCompared: currentHour,
    isLowerBoundInclusive: true
  })) {
    return PartOfTheDay.EVENING;
  }
  return PartOfTheDay.LATE_NIGHT;
};
export default getPartOfTheDay;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/utils/dist/esm/date/getPartOfTheDay.js
// module id = 2851
// module chunks = 11